export default __webpack_public_path__ + "static/media/chocolate-lava-cake.9d33e28e.jpg";